export const onboardingCustomizeStrings = {
  // ── Shared ─────────────────────────────────────────────────────────────────
  error: 'Algo salió mal. Inténtalo de nuevo.',
  loading: 'Configurando tu cuenta...',

  // ── Step 1 — Templates ─────────────────────────────────────────────────────
  step1Title: 'Revisa tus plantillas',
  step1Desc:
    'Estas son las plantillas que usarás como punto de partida para tus protocolos. Puedes editarlas, eliminarlas o añadir las tuyas.',
  step1Add: '+ Crear otra plantilla',
  step1Continue: 'Continuar a tipos',
  step1Back: 'Volver al inicio',
  step1Empty: 'Necesitas al menos una plantilla para continuar.',
  step1TemplatePlaceholder: 'Nombre de la plantilla',
  step1DeleteLabel: 'Eliminar',

  // ── Step 2 — Types ─────────────────────────────────────────────────────────
  step2Title: 'Revisa tus tipos',
  step2Desc:
    'Cada tipo apunta a una plantilla. Los doctores verán los tipos al crear protocolos; las plantillas quedan detrás.',
  step2Add: '+ Crear otro tipo',
  step2Finish: 'Finalizar configuración',
  step2Back: 'Volver a plantillas',
  step2Empty: 'Necesitas al menos un tipo para continuar.',
  step2TypePlaceholder: 'Nombre del tipo',
  step2DeleteLabel: 'Eliminar',
} as const
